import React from 'react'
import { useLocale } from '../contexts/LocaleContext'

/**
 * Top-of-site announcement. Currently the iPhone and Android apps.
 */
const TransitionBanner: React.FC = () => {
  const { t } = useLocale()
  const [before, after] = String(t('banner.text')).split('{brand}')

  return (
    <div className="bg-surface-inverse px-5 py-2.5 text-center text-[13px] text-neutral-300">
      {before}
      <b className="font-display text-peach-500">RallyShift</b>
      {after}{' '}
      <a href="/#app" className="text-neutral-50 underline">
        {t('banner.link')}
      </a>
    </div>
  )
}

export default TransitionBanner
